import { Box, Button, Fade, Paper, Typography } from "@mui/material";
import { grey } from "@mui/material/colors";
import { useEffect, useRef, useState } from "react";
import { useMap } from "react-map-gl";
import { useRecoilState } from "recoil";
import { enabledResetButtonState } from "../context/states";
import { initialMapView } from "../styles/mapStyles";
import LocationsToDisplay from "./LocationsToDisplay";
import SidebarLocation from "./SidebarLocation";

function PointsList({
  locations,
  onLocationSelected,
  sidebarOpen = true,
  setSidebarOpen,
}) {
  const { map } = useMap();

  const [locationsToDisplay, setLocationsToDisplay] = useState([]);
  const [enabledResetButton, setEnabledResetButton] = useRecoilState(
    enabledResetButtonState,
  );

  let lastChange = useRef(0);
  const TIMEOUT = 75;

  const flyTo = (geometry) => {
    map.easeTo({
      center: geometry.coordinates,
      zoom: 15,
      duration: 1500,
    });
  };

  const resetMap = () => {
    map.easeTo({
      center: [initialMapView.longitude, initialMapView.latitude],
      zoom: initialMapView.zoom,
      duration: 1500,
    });

    setTimeout(() => {
      setEnabledResetButton(false);
    }, 1525);

    const isMobile = window?.matchMedia("(max-width: 899px)").matches ?? false;
    if (isMobile) {
      setSidebarOpen(false);
    }
  };

  const handleLocationSelected = (location) => {
    flyTo(location.geometry);
    if (onLocationSelected && typeof onLocationSelected === "function") {
      onLocationSelected(location);
    }
  };

  useEffect(() => {
    if (!map) return;

    const onMove = (delay = true) => {
      if (!sidebarOpen && !window.matchMedia("(max-width: 899px)").matches)
        return;

      if (delay) {
        lastChange.current = Date.now();
        setTimeout(filterLocations, TIMEOUT);
      } else {
        filterLocations();
      }
    };

    map.on("move", onMove);
    onMove(false);

    return () => {
      map.off("move", onMove);
    };
  }, [map, locations]);

  const filterLocations = () => {
    if (!locations) {
      setTimeout(filterLocations, TIMEOUT);
      return;
    }
    if (lastChange.current < Date.now() - TIMEOUT) {
      const bounds = map.getBounds();
      setLocationsToDisplay(
        locations.features.filter((location) => {
          const lng = location.geometry.coordinates[0];
          const lat = location.geometry.coordinates[1];

          return bounds.contains([lng, lat]);
        }),
      );
    } else {
      setTimeout(filterLocations, TIMEOUT);
    }
  };

  return (
    <Paper sx={locationsWrapperStyles} variant="locations-wrapper">
      {locationsToDisplay.length > 0 ? (
        <Box>
          {locationsToDisplay.map((location, index) => {
            return (
              <SidebarLocation
                key={`location-${index}`}
                location={location}
                onLocationSelected={handleLocationSelected}
              />
            );
          })}
        </Box>
      ) : (
        <LocationsToDisplay>
          <Typography>Keine Inhalte vorhanden</Typography>
        </LocationsToDisplay>
      )}
      <LocationsToDisplay>
        {enabledResetButton && (
          <Fade in={enabledResetButton}>
            <Button
              size="small"
              variant="outlined"
              color="secondary"
              sx={{ mb: "0.5rem" }}
              fullWidth
              onClick={resetMap}
            >
              Zurück zur Übersicht
            </Button>
          </Fade>
        )}

        <Typography
          sx={{ fontSize: "0.875rem !important", textTransform: "uppercase" }}
        >
          Gesamt
        </Typography>
        <Typography>
          {locationsToDisplay?.length} von {locations?.features?.length}{" "}
          Ergebnissen
        </Typography>
      </LocationsToDisplay>
    </Paper>
  );
}

export default PointsList;

const locationsWrapperStyles = {
  backgroundColor: grey[900],
  position: "relative",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
};
